const SquareUpRight = ({
  width = 24,
  height = 24,
  fill = "currentColor",
  ...props
}) => (
  <svg
    {...props}
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
      fill={fill}
    />
    <path
      d="M14.8298 12.6799C14.4198 12.6799 14.0798 12.3399 14.0798 11.9299V8.43994H10.5898C10.1798 8.43994 9.83984 8.09994 9.83984 7.68994C9.83984 7.27994 10.1798 6.93994 10.5898 6.93994H14.8298C15.2398 6.93994 15.5798 7.27994 15.5798 7.68994V11.9299C15.5798 12.3399 15.2398 12.6799 14.8298 12.6799Z"
      fill={fill}
    />
    <path
      d="M9.16986 14.0901C8.97986 14.0901 8.78986 14.0201 8.63986 13.8701C8.34986 13.5801 8.34986 13.1001 8.63986 12.8101L14.2999 7.15012C14.5899 6.86012 15.0699 6.86012 15.3599 7.15012C15.6499 7.44012 15.6499 7.92013 15.3599 8.21013L9.69986 13.8701C9.55986 14.0201 9.35986 14.0901 9.16986 14.0901Z"
      fill={fill}
    />
    <path
      d="M12 18.2302C9.88995 18.2302 7.76995 17.8902 5.75995 17.2202C5.36995 17.0902 5.15995 16.6602 5.28995 16.2702C5.41995 15.8802 5.84996 15.6602 6.23996 15.8002C9.95996 17.0402 14.05 17.0402 17.77 15.8002C18.16 15.6702 18.59 15.8802 18.72 16.2702C18.85 16.6602 18.64 17.0902 18.25 17.2202C16.23 17.9002 14.11 18.2302 12 18.2302Z"
      fill={fill}
    />
  </svg>
);

export default SquareUpRight;
